var App = App || {};

App.JournalAlertsSignUp = (function() {

    var selectedCheckBoxesOnModalPopup = {};

    return {
        init: init
    };

    function init() {
        if (!_myComponentIsOnPage()) {
            return;
        }

        initFilters();
        $('.js-select-button').on('click', selectButtonClicked);
        $('.sr-facet').on('click', '.js-uncheck-list-item', unselectCheckItem);
        $('.js-submit-issues-alert-button').on('click', submitIssuesAlert);
    }

    function _myComponentIsOnPage() {
        return $('.js-journals-alerts-sign-up-wrapper').length;
    }

    function initFilters() {
        $('.js-apply-filter-button').on('click', applySelection);
        $('.js-apply-filter-button').on('keypress', handleKeyPress);
        $('.js-alert-resources-modal-list').on('close.fndtn.reveal', closingModal);
    }


    function handleKeyPress(e) {
        if (e.which === 13) { // Enter key code
            $(this).click();
        }
    }

    function closingModal() {
        var $ul = $(this).find('ul');
        var previouslyCheckedInputs = selectedCheckBoxesOnModalPopup.selectedCheckBoxes;
        var previousIds = previouslyCheckedInputs.map(function () {
            return $(this).data('id');
        }).get();
        var currentCheckedInputs = $ul.find('.chkSelect:checked');
        var currentIds = currentCheckedInputs.map(function () {
            return $(this).data('id');
        }).get();

        var isDifferent = previousIds.length !== currentIds.length || previousIds.some(id => !currentIds.includes(id));
        if (isDifferent) {
            $ul.find('.chkSelect').each(function () {
                var $input = $(this);
                var id = $input.data('id');
                var wasChecked = previousIds.includes(id);
                $input.prop('checked', wasChecked);
            });
        }

        var $filterInput = $(this).find('.js-facet-filter-box');
        if ($filterInput.length > 0 && $filterInput.val()) {
            $filterInput.val('');
            $filterInput.trigger('keyup');
        }
    }

    function selectButtonClicked() {
        var $selectButton = $(this);
        var $ul = $selectButton.closest('.js-resource-list-wrapper').find('ul');       
        selectedCheckBoxesOnModalPopup = { selectedCheckBoxes: $ul.find('.chkSelect:checked') };
    }

    function unselectCheckItem() {
        var $unselectButton = $(this);
        var resourceId = $unselectButton.data('id');
        var resourceParam = $unselectButton.data('resource-param');

        var $ul = $unselectButton.closest('.js-resource-list-wrapper').find('ul');
        
        var $checkbox = $ul.find('input[type="checkbox"][data-id="' + resourceId + '"]');
        $checkbox.prop('checked', false);

        var selectedIds = [];
        $ul.find('.chkSelect:checked').each(function () {
            var selectedResourceId = $(this).data('id');
            selectedIds.push(selectedResourceId);
        });

        if (resourceParam != null) {
            var newUrl = App.HistoryManager.Push(resourceParam, selectedIds);
            window.location.href = newUrl;
        }
    }

    function applySelection() {
        var $applyButton = $(this);
        var resourceParam = $applyButton.data('resource-param');

        var $modal = $applyButton.closest('.js-alert-resources-modal-list')
        var $ul = $modal.find('ul');
        var selectedCheckBoxes = $ul.find('.chkSelect:checked');

        var selectedIds = selectedCheckBoxes.map(function () {
            return $(this).data('id');
        }).get();

        if (resourceParam != null) {
            var newUrl = App.HistoryManager.Push(resourceParam, selectedIds);
            window.location.href = newUrl;
        }
    }


    function submitIssuesAlert() {
        $('.failure-alert-message').addClass('hidden');

        var selectedIds = _getCheckedIds('#resourcesListJournal');
        var selectedCollectionIds = _getCheckedIds('#resourcesListCollection');

        if (selectedIds.length === 0 && selectedCollectionIds.length === 0) {
            var currentResourceId = $('#currentJournal').data('resource-id');
            if (currentResourceId !== undefined) {
                selectedIds = [parseInt(currentResourceId)];
            }
            else {
                return;
            }
        }

        var postData = {
            selectedResourcesIds: selectedIds,
            selectedCollectionIds: selectedCollectionIds
        };

        SCM.Ajax.post('/AlertSignUp/CreateJournalsIssuesAlert', postData)
            .expectJson()
            .then((response) => {
                if (response.Success) {
                    $('.success-alert-message').removeClass('hidden');
                    $('.js-journalsIssuesAlertBody').addClass('hidden');
                    $('.js-journalsIssuesAlertFooter').addClass('hidden');
                    App.HistoryManager.Pop('f_JournalID');
                    App.HistoryManager.Pop('f_JournalCollectionID');
                } else if (response.Messages.length > 0) {
                    $('.failure-alert-message').text(response.Messages[0]).removeClass('hidden');
                }
            })
            .catch(function (error) {
                $('.failure-alert-message').text(error.userFriendlyMessage).removeClass('hidden');
            });
    }

    function _getCheckedIds(listSelector) {
        return $(listSelector + ' li').get()
            .map(li => $(li).find('input.chkSelect'))
            .filter(input => input.prop('checked'))
            .map(input => parseInt(input.data('id')));
    }
})(jQuery);